import {Grid} from '@yandex-delivery/blocks'
import {Image} from '@yandex-delivery/blocks/image'
import {tag2url} from '@yandex-delivery/utils'
import * as classes from './HeaderRu@desktop.classes'
import React from 'react'
import {FloatingBox, StickyTo} from '@yandex-delivery/form/ui/OrderForm/components/FloatingBox'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export function Header({user}: {user: React.ReactNode}): React.ReactElement {
  return (
    <FloatingBox height={spacing(10)} stickyTo={StickyTo.BLOCK_START} className={classes.box}>
      <header className={classes.header}>
        <a href="/">
          <Image alt="Яндекс Доставка" height={30} srcSet={tag2url('delivery_landing_logo')} width="auto" />
        </a>
        <Grid alignItems="center" wrap="nowrap" item>
          {user}
        </Grid>
      </header>
    </FloatingBox>
  )
}
